<template>
  <div class="w-100 h-100">
    <div class="w-75 mx-auto">
      <div class="row my-2">
        <div class="col-12 mb-2">
          <div class="image-wrapper">
            <div
              @click="openImageModal(snapshotImgFile)"
              v-b-modal.image_modal
              class="click-cover"
            >
              <div class="overlay-top">
                <span class="d-block">{{ dataMatch.cameraName }}</span>
                <span class="d-block">{{
                  dataMatch.unit.description
                }}</span>
                <span class="timestamp">{{ formatDateAssigned(dataMatch.created) }}</span>
              </div>

              <div
                v-if="snapshotImgFile" @click="openImageModal(snapshotImgFile)"
                class="overlay-bottom"
              >
                <span>{{ data.name }}</span>
              </div>
            </div>
            <img
              v-if="snapshotImgFile"
              class="img-thumbnail"
              :src="snapshotImgFile" alt=""
              @click="openImageModal(snapshotImgFile)"
              v-b-modal.image_modal
            />
          </div>
        </div>

        <div class="col-6 text-center">
          <img
            class="img-thumbnail"
            :src="enrolledProfileImgUrl" alt=""
            @click="openImageModal(enrolledProfileImgUrl)"
            v-b-modal.image_modal
          />
          <p class="my-0 mt-1">
            {{ $t("grid.slots.info.fr.enrolled_person") }}
          </p>
        </div>
        <div class="col-6 text-center">
          <img
            class="img-thumbnail"
            :src="portraitImgUrl" alt=""
            @click="openImageModal(portraitImgUrl)"
            v-b-modal.image_modal
          />
          <p class="my-0 mt-1 text-center">
            {{ $t("grid.slots.info.fr.face_detected") }}
          </p>
        </div>
      </div>
    </div>
    <table class="table table-sm" v-if="data">
      <tr>
        <th>{{ $t("grid.slots.info.fr.similarity") }}:</th>
        <td>{{ formatPercentages(data.score_similarity) }}</td>
      </tr>
      <tr>
        <th>{{ $t("grid.slots.info.fr.list_name") }}:</th>
        <td>{{ data.list }}</td>
      </tr>
      <tr>
        <th>{{ $t("grid.slots.info.fr.age") }}:</th>
        <td>{{ formatNum(data.age) }}</td>
      </tr>
      <tr>
        <th>{{ $t("grid.slots.info.fr.gender") }}</th>
        <td>{{ data.gender }}</td>
      </tr>
      <tr>
        <th>{{ $t("grid.slots.info.fr.emotion") }}:</th>
        <td>{{ data.emotion }}</td>
      </tr>
      <tr>
        <th>{{ $t("grid.slots.info.fr.glasses") }}:</th>
        <td>{{ $t(`boolean.${data.glasses ? "y" : "n"}`) }}</td>
      </tr>
      <tr class="full-width-block-row">
        <td class="center-flex-cell">
          <b-button
            variant="outline-primary"
            :to="service === 'Ntechlab' ? urlNtechlab : `/facial_recognition/${data.personId}`"
            class="dark-mode-btn"
            >{{ $t("grid.slots.info.fr.match_history") }}</b-button
          >
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from "@axios";
import { BButton } from "bootstrap-vue";
import moment from "moment-timezone";
import store from "@/store";

export default {
  components: {
    BButton,
  },
  props: {
    fromAlarmSlot: Boolean,
    frData: Object,
    dataMatch: Object,
    index: Number,
  },
  data() {
    return {
      isCollapseOpen: false,
      data: {
        personId: "",
        quality: {
          blurriness: "",
          dark: "",
          light: "",
          saturation: "",
        },
      },
      snapshotImgUrl: "",
      portraitImgUrl: "",
      enrolledProfileImgUrl: "",

      snapshotImgFile: "",
      portraitImgFile: "",
      enrolledProfileImgFile: "",
      service: "",
      urlNtechlab: "",
    };
  },
  async mounted() {
    console.log('mounted - frData:', this.frData);
    this.snapshotImgFile = `${this.dataMatch.url}` ?? false;
    this.portraitImgUrl = `${this.dataMatch.url_portraitImg}` ?? false;
    this.enrolledProfileImgUrl = `${this.dataMatch.url_enrolledProfileImg}` ?? false;

    this.data = this.dataMatch;
    this.service = this.dataMatch.service;
    this.urlNtechlab = "/detection_event?ntechLabAll=" + this.frData.alarm_id;
  },
  methods: {
    formatPercentages(num) {
      return `${(parseFloat(num) * 100).toFixed(2)} %`;
    },
    formatNum(num, decimals = 0) {
      return parseFloat(num).toFixed(decimals);
    },
    formatDateAssigned(value) {
      const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
      return formattedDate;
    },
    async openImageModal(imageUrl){
      await store.dispatch("image_modal/imageUrl", imageUrl );
    }
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;

  .dark-mode-btn {
    margin: 0 auto;
  }
}

.dark-mode-btn {
  &.btn-outline-primary {
    .dark-layout & {
      color: #cecdd6;
      border-color: #12111c;
      background-color: #0f1e2c;

      &:hover, &:focus, &:active {
        background-color: #19324a !important;
        color: #fff !important;
      }
    }
  }
}

/* === Extraído de estilos inline === */
.image-wrapper {
  position: relative;
  display: inline-block;
  overflow: hidden;
}

.click-cover {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
}

.overlay-top {
  color: #fff;
  width: 100%;
  text-shadow: 1px 2px #000;
  padding: 0.5rem;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(
    0deg,
    transparent 0%,
    rgba(0, 0, 0, 0.5) 95%
  );
}

.overlay-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  color: #fff;
  width: 100%;
  text-shadow: 1px 2px #000;
  padding: 0.5rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
}

.timestamp {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem;
}

.full-width-block-row {
  display: block;
  width: 100%;
}

.center-flex-cell {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
